import {
  Form,
  Select,
  Row,
  Col,
  Button,
  Radio,
  Modal,
  AutoComplete,
  Input,
  Spin,
  DatePicker,
  Upload,
  Icon,
  TimePicker,
  Checkbox
} from "antd";
import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import {
  showSuccessNotification,
  showErrorNotification,
  newsTypes
} from "../../helpers";
import {
  addNewsArticle,
  getBasicClinicSpecialities,
  getBasicPharmas
} from "../../services";
import ReactTags from "react-tag-autocomplete";
import AddressView from "./AddressView";
import NumericInput from "../../helpers/NumericInput";

const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const toMonth = new Date(currentYear, currentMonth);

class NewsFeedView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      specialities: [],
      city: null,
      address: null
    };

    this.reactTags = React.createRef();
    this.specReactTags = React.createRef();
  }

  componentDidMount() {
    this.fetchSpecialities();
    this.fetchBasicPharmas();
  }

  /**
   * @function fetchBasicPharmas
   * @desc This will handle fetching basic pharmas
   */
  fetchBasicPharmas = searchText => {
    const perPage = 50;

    getBasicPharmas(searchText, perPage).then(response => {
      if (response?.data?.hits?.hits?.length > 0) {
        const { hits } = response.data.hits;
        let basicPharmas = [];
        basicPharmas = hits.map(resObj => {
          const tempObj = resObj._source;
          return {
            value: tempObj.name,
            key: tempObj.id,
            pharmaObj: tempObj
          };
        });

        this.setState({
          basicPharmas
        });
      } else {
        this.setState({
          basicPharmas: []
        });
      }
    });
  };

  /**
   * @function saveNewsArticle
   * @description it will save form data and hit the api
   */
  saveNewsArticle = e => {
    const {
      form,
      ImgPhotoUrl,
      sourceThumbnailUrl,
      tags,
      selectedSpecialities
    } = this.props;

    const selectedSpecialitiesIds = selectedSpecialities.map(a => a.id);

    if (e) e.preventDefault();

    form.validateFieldsAndScroll((err, value) => {
      if (!err) {
        const { toggleIsProcessing, stopIsProcessing } = this.props;
        toggleIsProcessing();
        const newsArticle = {
          news_article: {
            news_text: value.description,
            source_name: value.source_name,
            source_link: value.source_url,
            news_date: moment(value.date).format("YYYY-MM-DD"),
            news_type: value.news_type,
            city: value.city,
            state: value.state,
            basic_clinic_specialities: selectedSpecialitiesIds,
            news_label: value.newsLabel
          }
        };

        newsArticle.news_article.photo_url = ImgPhotoUrl;
        newsArticle.news_article.source_thumbnail_url = sourceThumbnailUrl;
        newsArticle.news_article.news_tags = tags;

        if (value.news_type === "CME") {
          const startDate = moment(value.start_date).format("YYYY-MM-DD");
          const endDate = moment(value.end_date).format("YYYY-MM-DD");
          const startTime = moment(value.start_time).format("HH:mm");
          const endTime = moment(value.end_time).format("HH:mm");

          let startDateTime = moment(
            startDate + " " + startTime,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm");

          startDateTime = moment(startDateTime).toISOString();

          // add calculated values to respective nodes
          newsArticle.news_article.event_start_ts = startDateTime;

          let endDateTime = moment(
            endDate + " " + endTime,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm");
          if (value.end_time) endDateTime = moment(endDateTime).toISOString();
          else
            endDateTime = moment(endDateTime)
              .endOf("day")
              .toISOString();

          newsArticle.news_article.event_end_ts = endDateTime;

          newsArticle.news_article.all_day = value.isAllday;
          newsArticle.news_article.event_type = value.eventType;
          newsArticle.news_article.credit_hours = value.credit_hours;
          newsArticle.news_article.title = value.heading;
        } else if (value.news_type === "PHARMA") {
          newsArticle.news_article.basic_pharma_id = value.pharmacy;
        } else {
          newsArticle.news_article.title = value.heading;
        }

        addNewsArticle(newsArticle)
          .then(response => {
            if (response.data.success) {
              const successMsg = "News article added successfully.";
              showSuccessNotification(successMsg);
              this.props.getNewsTagsList();
              this.props.getArticlesList();
              this.resetForm();
            } else {
              const { errors } = response.data;
              let error = errors;
              showErrorNotification(error);
            }
            stopIsProcessing();
          })
          .catch(() => {
            toggleIsProcessing();
          });
      }
    });
  };

  /**
   * @function updateNewsArticle
   * @description it will update form data and hit the api
   */
  updateNewsArticle = e => {
    const {
      form,
      ImgPhotoUrl,
      sourceThumbnailUrl,
      tags,
      selectedRecord,
      selectedSpecialities
    } = this.props;

    if (e) e.preventDefault();

    const selectedSpecialitiesIds = selectedSpecialities.map(a => a.id);
    form.validateFieldsAndScroll((err, value) => {
      if (!err) {
        const { toggleIsProcessing, stopIsProcessing } = this.props;
        toggleIsProcessing();
        const newsArticle = {
          news_article: {
            news_text: value.description,
            source_name: value.source_name,
            source_link: value.source_url,
            news_date: moment(value.date).format("YYYY-MM-DD"),
            news_type: value.news_type,
            city: value.city,
            state: value.state,
            basic_clinic_specialities: selectedSpecialitiesIds,
            news_label: value.newsLabel
          }
        };
        newsArticle.news_article.photo_url = ImgPhotoUrl;

        newsArticle.news_article.source_thumbnail_url = sourceThumbnailUrl;
        newsArticle.news_article.news_tags = tags;
        newsArticle.news_article.id = selectedRecord.id;

        if (value.news_type === "CME") {
          const startDate = moment(value.start_date).format("YYYY-MM-DD");
          const endDate = moment(value.end_date).format("YYYY-MM-DD");
          const startTime = moment(value.start_time).format("HH:mm");
          const endTime = moment(value.end_time).format("HH:mm");

          let startDateTime = moment(
            startDate + " " + startTime,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm");
          startDateTime = moment(startDateTime).toISOString();

          // add calculated values to respective nodes
          newsArticle.news_article.event_start_ts = startDateTime;

          let endDateTime = moment(
            endDate + " " + endTime,
            "YYYY-MM-DD HH:mm"
          ).format("YYYY-MM-DD HH:mm");

          if (value.end_time) endDateTime = moment(endDateTime).toISOString();
          else
            endDateTime = moment(endDateTime)
              .endOf("day")
              .toISOString();

          newsArticle.news_article.event_end_ts = endDateTime;
          newsArticle.news_article.all_day = value.isAllday;
          newsArticle.news_article.event_type = value.eventType;
          newsArticle.news_article.credit_hours = value.credit_hours;
          newsArticle.news_article.title = value.heading;
        } else if (value.news_type === "PHARMA") {
          newsArticle.news_article.basic_pharma_id = value.pharmacy;
        } else {
          newsArticle.news_article.title = value.heading;
        }

        addNewsArticle(newsArticle)
          .then(response => {
            if (response.data.success) {
              // toggleIsProcessing();
              const successMsg = "News article updated successfully.";
              showSuccessNotification(successMsg);
              this.setState({
                editField: false,
                fileList: [],
                thumbnailImageArray: []
              });
              this.props.getNewsTagsList();
              this.props.getArticlesList();
              this.resetForm();
            } else {
              const { errors } = response.data;
              let error = errors;
              showErrorNotification(error);
            }
            stopIsProcessing();
          })
          .catch(() => {
            toggleIsProcessing();
          });
      }
    });
  };

  /**
   * @function resetForm
   * @description This function handles resetting form
   */
  resetForm = () => {
    this.props.toggleAddModal();
    this.props.form.resetFields();
    this.props.resetFormData();
  };

  /*
   * @function fetchSpecialities
   * @param "searchText"
   * @description this function fetches clinic specialities
   */
  fetchSpecialities = searchText => {
    this.setState({
      speciality: {
        id: "",
        name: searchText
      }
    });

    getBasicClinicSpecialities(searchText)
      .then(res => {
        if (res?.data?.hits?.hits?.length > 0) {
          const { hits } = res.data.hits;
          let specialities = [];
          specialities = hits.map(resObj => {
            const tempObj = resObj._source;
            return {
              name: tempObj.name,
              basic_speciality_id: tempObj.id,
              id: tempObj.id
              // major_speciality: tempObj.major_speciality
            };
          });

          // let majorSpecialities = specialities.filter(resObj => {
          //   if (resObj.major_speciality) return resObj;
          // });

          this.setState({
            specialities
          });
        } else {
          this.setState({
            specialities: []
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  /*
   * @function searchSpecialities
   * @param "value"
   * @description this function handles filter specialities
   */
  searchSpecialities = value => {
    if (value && value.length > 1) {
      const specVal = value.replace(/[^a-zA-Z ]/g, "");
      this.fetchSpecialities(specVal);
    }
  };

  /*
   * @function disabledDate
   * @param "current"
   * @description this function handles disabling dates in calendar
   */
  disabledDate = current => {
    // Can not select days before today and today
    return current && current < moment().startOf("day");
  };

  /*
   * @function handleSearchPharmacy
   * @param "searchTerm"
   * @description this function handles fetching pharmacies according to searched term
   */
  handleSearchPharmacy = searchTerm => {
    this.fetchBasicPharmas(searchTerm);
  };

  render() {
    const {
      previewVisible,
      previewImage,
      fileList,
      handleChange,
      handlePreview,
      handleCancel,
      ImagecustomRequest,
      thumbnailCustomRequest,
      handleThumbnailPreview,
      handleThumbnailPhotoChange,
      handlethumbnailPhotoCancel,
      thumbnailPreviewVisible,
      thumbnailPreviewImage,
      thumbnailImageArray,
      showAddModal,
      tags,
      suggestions,
      onDelete,
      onAddition,
      selectedRecord,
      editField,
      selectedSpecialities,
      onSpecDelete,
      onSpecAddition,
      city,
      address,
      handleCityChange,
      setCity,
      isProcessing,
      form
    } = this.props;
    const { specialities, basicPharmas } = this.state;

    let date = moment(selectedRecord.news_date);
    const { getFieldDecorator } = this.props.form;

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Modal
        maskClosable={false}
        destroyOnClose
        title={editField ? "Edit News Article" : "Add News Article"}
        visible={showAddModal}
        onCancel={this.resetForm}
        footer={null}
        className="news-feed-form no-footer"
      >
        <Form
          onSubmit={editField ? this.updateNewsArticle : this.saveNewsArticle}
          layout="vertical"
          className="mt-20"
        >
          <Row type="flex" gutter={20}>
            <Col span={6} className="appt_date_col">
              <FormItem label={"Date"} className="appointment_date">
                {getFieldDecorator("date", {
                  initialValue: date,
                  rules: [
                    {
                      required: true,
                      message: `${"Enter Date"}`
                    }
                  ]
                })(<DatePicker type="date" />)}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label={`News type`}>
                {getFieldDecorator("news_type", {
                  initialValue: selectedRecord && selectedRecord.news_type,
                  rules: [
                    {
                      required: true,
                      message: `Please select news type`
                    }
                  ]
                })(
                  <Select style={{ width: 120 }}>
                    {newsTypes &&
                      newsTypes.length > 0 &&
                      newsTypes.map(obj => {
                        return <Option value={obj}>{obj}</Option>;
                      })}
                  </Select>
                )}
              </FormItem>
            </Col>
            {form.getFieldValue("news_type") === "PHARMA" && (
              <Col span={12}>
                <FormItem label={`Select pharmacy`}>
                  {getFieldDecorator("pharmacy", {
                    initialValue:
                      selectedRecord && selectedRecord.basic_pharma_id,
                    rules: [
                      {
                        required: true,
                        message: `Please select pharmacy`
                      }
                    ]
                  })(
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onSearch={this.handleSearchPharmacy}
                    >
                      {basicPharmas &&
                        basicPharmas.length > 0 &&
                        basicPharmas.map(obj => {
                          return <Option value={obj.key}>{obj.value}</Option>;
                        })}
                    </Select>
                  )}
                </FormItem>
              </Col>
            )}
          </Row>
          {form.getFieldValue("news_type") !== "PHARMA" && (
            <Row type="flex" gutter={20}>
              <Col span={form.getFieldValue("news_type") === "CME" ? 18 : 24}>
                <FormItem
                  label={
                    form.getFieldValue("news_type") === "CME"
                      ? "Event title"
                      : "News Heading"
                  }
                >
                  {getFieldDecorator("heading", {
                    initialValue: selectedRecord && selectedRecord.title,
                    rules: [
                      {
                        required: true,
                        message: `${"enter news heading"}`
                      }
                    ]
                  })(<Input placeholder="News heading" />)}
                </FormItem>
              </Col>

              {form.getFieldValue("news_type") === "CME" && (
                <Col span={6}>
                  <FormItem label={"Credits (in hours)"}>
                    {getFieldDecorator("credit_hours", {
                      initialValue:
                        selectedRecord && selectedRecord.credit_hours
                    })(<NumericInput placeholder="Eg. 2" />)}
                  </FormItem>
                </Col>
              )}
            </Row>
          )}

          {form.getFieldValue("news_type") === "CME" && (
            <>
              <Row type="flex" gutter={20}>
                <Col span={12}>
                  <Row type="flex" gutter={20}>
                    <Col span={12}>
                      <FormItem label={"From date"}>
                        {getFieldDecorator("start_date", {
                          initialValue:
                            selectedRecord && selectedRecord.event_start_ts
                              ? moment(selectedRecord.event_start_ts)
                              : "",

                          rules: [
                            {
                              required: true,
                              message: `Please select from date`
                            }
                          ]
                        })(
                          <DatePicker
                            type="date"
                            disabledDate={this.disabledDate}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label={"From time"}>
                        {getFieldDecorator("start_time", {
                          initialValue:
                            selectedRecord && selectedRecord.event_start_ts
                              ? moment(selectedRecord.event_start_ts)
                              : ""
                        })(
                          <TimePicker
                            placeholder="Time"
                            use12Hours
                            format="hh:mm a"
                            className="form-timepicker"
                            minuteStep={30}
                          />
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row type="flex" gutter={20}>
                    <Col span={12}>
                      <FormItem label={"End date"}>
                        {getFieldDecorator("end_date", {
                          initialValue:
                            selectedRecord && selectedRecord.event_end_ts
                              ? moment(selectedRecord.event_end_ts)
                              : "",
                          rules: [
                            {
                              required: true,
                              message: `Please select end date`
                            }
                          ]
                        })(
                          <DatePicker
                            type="date"
                            disabledDate={this.disabledDate}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label={"End time"}>
                        {getFieldDecorator("end_time", {
                          initialValue:
                            selectedRecord && selectedRecord.event_end_ts
                              ? moment(selectedRecord.event_end_ts)
                              : ""
                        })(
                          <TimePicker
                            placeholder="Time"
                            use12Hours
                            format="hh:mm a"
                            className="form-timepicker"
                            minuteStep={30}
                          />
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row type="flex" gutter={20}>
                <Col span={6}>
                  <FormItem>
                    {getFieldDecorator("isAllday", {
                      initialValue: selectedRecord && selectedRecord.all_day
                    })(
                      <Checkbox
                        defaultChecked={
                          selectedRecord && selectedRecord.all_day
                        }
                      >
                        All day
                      </Checkbox>
                    )}
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem>
                    {getFieldDecorator("eventType", {
                      initialValue:
                        (selectedRecord && selectedRecord.event_type) ||
                        "virtual"
                    })(
                      <Radio.Group defaultValue={"virtual"}>
                        <Radio value={"virtual"}>Virtual</Radio>
                        <Radio value={"in-person"}>In-person</Radio>
                      </Radio.Group>
                    )}
                  </FormItem>
                </Col>
              </Row>
            </>
          )}

          <Row type="flex" gutter={20}>
            <Col span={6}>
              <FormItem label={"News Image"}>
                {getFieldDecorator("photo_img", {
                  initialValue: selectedRecord && selectedRecord.photo_url,
                  rules: []
                })(
                  <div className="clearfix">
                    <Upload
                      customRequest={ImagecustomRequest}
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={handlePreview}
                      onChange={handleChange}
                      accept=".jpeg, .jpg, .png, .tiff"
                      multiple={false}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                    <Modal
                      visible={previewVisible}
                      footer={null}
                      onCancel={handleCancel}
                    >
                      <img
                        alt="example"
                        style={{ width: "100%" }}
                        src={previewImage}
                      />
                    </Modal>
                  </div>
                )}
              </FormItem>
            </Col>

            <Col span={18}>
              <FormItem label={"News Description"}>
                {getFieldDecorator("description", {
                  initialValue: selectedRecord && selectedRecord.news_text,
                  rules: [
                    {
                      required: true,
                      message: `${"Add description"}`
                    }
                  ]
                })(<TextArea rows={5} />)}
              </FormItem>
            </Col>
          </Row>

          <Row type="flex" gutter={20}>
            <Col span={6}>
              <FormItem label={"Source Thumbnail"}>
                {getFieldDecorator("thumbnail", {
                  initialValue:
                    selectedRecord && selectedRecord.source_thumbnail_url
                })(
                  <div className="clearfix">
                    <Upload
                      customRequest={thumbnailCustomRequest}
                      listType="picture-card"
                      fileList={thumbnailImageArray}
                      onPreview={handleThumbnailPreview}
                      onChange={handleThumbnailPhotoChange}
                      multiple={false}
                    >
                      {thumbnailImageArray.length >= 1 ? null : uploadButton}
                    </Upload>
                    <Modal
                      visible={thumbnailPreviewVisible}
                      footer={null}
                      onCancel={handlethumbnailPhotoCancel}
                      className="text-center"
                    >
                      <img
                        alt="example"
                        style={{ maxWidth: "100%" }}
                        src={thumbnailPreviewImage}
                      />
                    </Modal>
                  </div>
                )}
              </FormItem>
            </Col>

            <Col span={18}>
              <Row>
                <Col className="source-name-btm">
                  <FormItem label={"Source Name"}>
                    {getFieldDecorator("source_name", {
                      initialValue:
                        selectedRecord && selectedRecord.source_name,
                      rules: [
                        {
                          required: true,
                          message: `${"enter source name"}`
                        }
                      ]
                    })(
                      <Input className="ant-input" placeholder="Source Name" />
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormItem label={"Source Url"}>
                    {getFieldDecorator("source_url", {
                      initialValue:
                        selectedRecord && selectedRecord.source_link,
                      rules: [
                        {
                          required: true,
                          message: `${"enter source url"}`
                        }
                      ]
                    })(
                      <Input className="ant-input" placeholder="Source url" />
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row type="flex" gutter={20}>
            <Col span={18}>
              <FormItem label={"Tags"}>
                {getFieldDecorator("tags", {
                  initialValue: tags ? tags : ""
                })(
                  <ReactTags
                    ref={this.reactTags}
                    tags={tags}
                    suggestions={suggestions}
                    onDelete={onDelete}
                    onAddition={onAddition}
                    allowNew
                  />
                )}
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label={"Label"}>
                {getFieldDecorator("newsLabel", {
                  initialValue: selectedRecord && selectedRecord.news_label
                })(<Input className="ant-input" />)}
              </FormItem>
            </Col>
          </Row>

          <Row type="flex" gutter={20}>
            <Col span={10}>
              <FormItem label="Speciality" className="remove-colon-lbl">
                {getFieldDecorator("speciality", {
                  rules: []
                })(
                  <ReactTags
                    ref={this.specReactTags}
                    tags={selectedSpecialities}
                    suggestions={specialities}
                    onDelete={onSpecDelete}
                    onAddition={onSpecAddition}
                    placeholderText="Add specialities"
                    onInput={this.searchSpecialities}
                  />
                )}
              </FormItem>
            </Col>
            <AddressView
              selectedRecord={selectedRecord}
              setCity={setCity}
              form={this.props.form}
              city={city}
              address={address}
              handleCityChange={handleCityChange}
            />
          </Row>

          <Row className="modal-footer-row">
            <Col span={24}>
              <Button
                type="primary"
                htmlType="submit"
                size="small"
                loading={isProcessing}
              >
                {editField ? "Update" : "Add"}
              </Button>
              <Button size="small" className="ml-8" onClick={this.resetForm}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

const NewsFeedForm = Form.create()(NewsFeedView);
export default NewsFeedForm;
